import Button from "@mui/material/Button";
import styled from "@mui/system/styled";
import type { ButtonProps } from "@mui/material";
import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";

type ButtonLinkProps = React.PropsWithChildren<
  ButtonProps & {
    to: LinkProps["to"];
    target?: LinkProps["target"];
    linkProps?: Omit<LinkProps, "to" | "target">;
  }
>;

const StyledLink = styled(Link)({
  color: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  textDecoration: "inherit",
});

export default function ButtonLink({
  to,
  target,
  linkProps,
  children,
  ...buttonProps
}: ButtonLinkProps) {
  return (
    <Button {...buttonProps}>
      <StyledLink to={to} target={target} {...linkProps}>
        {children}
      </StyledLink>
    </Button>
  );
}
